// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d53b4e7f","239":"10cbb6f0","453":"466a886f","455":"67b76a67"}[chunkId] + ".chunk.js";
};